module.exports = __webpack_public_path__ + "img/req.798e4423.svg";